import { render, staticRenderFns } from "./MailingListsPage.vue?vue&type=template&id=346a895a&"
import script from "./MailingListsPage.vue?vue&type=script&lang=ts&"
export * from "./MailingListsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports